import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.push.js";
var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        attrs: {
            "id": "app"
        }
    }, [
        _c('router-view'),
        _c('van-button', {
            staticClass: "nav",
            attrs: {
                "type": "danger",
                "size": "small",
                "round": ""
            },
            on: {
                "click": _setup.showPopup
            }
        }, [
            _vm._v("导")
        ]),
        _c('van-popup', {
            style: {
                height: '100%'
            },
            attrs: {
                "position": "top"
            },
            model: {
                value: _setup.show,
                callback: function callback($$v) {
                    _setup.show = $$v;
                },
                expression: "show"
            }
        }, [
            _c('van-collapse', {
                model: {
                    value: _setup.activeNames,
                    callback: function callback($$v) {
                        _setup.activeNames = $$v;
                    },
                    expression: "activeNames"
                }
            }, _vm._l(Object.keys(_setup.routesMaps).sort(), function(item) {
                return _c('van-collapse-item', {
                    key: item,
                    attrs: {
                        "title": item,
                        "name": item
                    }
                }, _vm._l(_setup.routesMaps[item], function(route, index) {
                    var _route_meta;
                    return _c('van-button', {
                        key: route.path,
                        attrs: {
                            "type": index % 2 === 0 ? 'primary' : 'warning',
                            "size": "small"
                        },
                        on: {
                            "click": function($event) {
                                return _setup.push(route);
                            }
                        }
                    }, [
                        _vm._v(" " + _vm._s((route === null || route === void 0 ? void 0 : (_route_meta = route.meta) === null || _route_meta === void 0 ? void 0 : _route_meta.title) || '暂无 title') + "-" + _vm._s((route === null || route === void 0 ? void 0 : route.path) || '') + " ")
                    ]);
                }), 1);
            }), 1)
        ], 1)
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
